var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE2C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.296 11.8148H13.7775V10.3333H12.296V11.8148ZM12.296 23.6667H13.7775V22.1852H12.296V23.6667ZM15.2589 23.6667H16.7404V22.1852H15.2589V23.6667ZM9.33301 23.6667H10.8145V22.1852H9.33301V23.6667ZM9.33301 20.7037H10.8145V19.2222H9.33301V20.7037ZM9.33301 17.7408H10.8145V16.2593H9.33301V17.7408ZM9.33301 14.7778H10.8145V13.2963H9.33301V14.7778ZM9.33301 11.8148H10.8145V10.3333H9.33301V11.8148ZM21.1849 20.7037H22.6663V19.2222H21.1849V20.7037ZM21.1849 17.7408H22.6663V16.2593H21.1849V17.7408ZM21.1849 23.6667H22.6663V22.1852H21.1849V23.6667ZM21.1849 14.7778H22.6663V13.2963H21.1849V14.7778ZM21.1849 10.3333V11.8148H22.6663V10.3333H21.1849ZM15.2589 11.8148H16.7404V10.3333H15.2589V11.8148ZM18.2219 23.6667H19.7034V22.1852H18.2219V23.6667ZM18.2219 11.8148H19.7034V10.3333H18.2219V11.8148Z",
    fill: "#5D3108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 12.25C29.644 12.25 30.1663 11.7277 30.1663 11.0833C30.1663 10.439 29.644 9.91667 28.9997 9.91667C28.3553 9.91667 27.833 10.439 27.833 11.0833C27.833 11.7277 28.3553 12.25 28.9997 12.25Z",
    fill: "#5D3108"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 1.75C28.358 1.75 27.833 2.275 27.833 2.91667V7.58333C27.833 8.225 28.358 8.75 28.9997 8.75C29.6413 8.75 30.1663 8.225 30.1663 7.58333V2.91667C30.1663 2.275 29.6413 1.75 28.9997 1.75Z",
    fill: "#5D3108"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmetIcon);
export default __webpack_public_path__ + "static/media/unmet-icon.ae404bca961912684070683128e042c7.svg";
export { ForwardRef as ReactComponent };